import { useEffect } from 'react';
import { gsap } from 'gsap';
import { useGetWindowSize } from '../../../hooks';
import { SIZE } from '../../../assets/styles/';
import { StepItemProps } from '../../../types';

export function useAnimateStepBar<T, K>(steps: StepItemProps<T, K>[]) {
  // Hook must be called at the top level, not inside useEffect
  const { width } = useGetWindowSize();

  useEffect(() => {
    if (width >= SIZE.laptop) {
      steps.forEach((_, index) => {
        const stepEl = document.querySelector('#step-' + index);
        const stepTextEl = document.querySelector('#step-text-' + index);

        if (stepEl) {
          gsap.fromTo(
            stepEl,
            {
              top: 0,
            },
            {
              top: (index - 1) * 100,
              // duration: 1.05,
              duration: 0,
              ease: 'power2.inOut',
            },
          );
        }

        if (stepTextEl) {
          gsap.fromTo(
            stepTextEl,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              // duration: 1.25,
              duration: 0,
              ease: 'power2.inOut',
            },
          );
        }
      });
    } else {
      steps.forEach((_, index) => {
        const stepEl = document.querySelector('#step-' + index);

        if (stepEl) {
          gsap.fromTo(
            stepEl,
            {
              left: 0,
            },
            {
              left: (index - 1) * 44,
              // duration: 0.95,
              duration: 0,
            },
          );
        }
      });
    }
  }, [steps.length, width]);
}
